import { parseRuntime } from './impl-helper';

export const getVarFactRender = async (params, almanac) => {
    const { runtime, variable, current } = await parseRuntime(params, almanac);
    const stateMachine = runtime.context.FEGORender.common.stateMachine;
    //处理默认的变量
    console.log(`=========[fego-condition][var-fact]`, variable, current);
    if (current.port.id === 'default') {
        //取出除了default之外的所有port
        const others = current?.node?.data?.factInfo?.outs?.filter((port) => port.id !== 'default') || [];
        //如果其它的port都不满足条件，那么就代表命中了default条件。那么就返回true
        const isAllFalse = others.every((port) => {
            const exppression = JSON.parse(port?.expression || '{}');
            const res = stateMachine.checkCondition(exppression, variable);
            return !res;
        });

        if (isAllFalse) {
            return true;
        }

        return false;
    }

    const exppression = JSON.parse(current.port?.expression || '{}');
    const res = stateMachine.checkCondition(exppression, variable);
    return res;
};
